var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSalesOrder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 5,
    transform: "matrix(-1 0 0 1 80 0)",
    fill: "#009AD8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58 43L59.5 40H49L50.2 37H60L61.5 34H45.9L47.1 31H61.78L63.5 28H56C56 26.9391 55.5786 25.9217 54.8284 25.1716C54.0783 24.4214 53.0609 24 52 24H28V32H22L16 40V50H20C20 51.5913 20.6321 53.1174 21.7574 54.2426C22.8826 55.3679 24.4087 56 26 56C27.5913 56 29.1174 55.3679 30.2426 54.2426C31.3679 53.1174 32 51.5913 32 50H40C40 51.5913 40.6321 53.1174 41.7574 54.2426C42.8826 55.3679 44.4087 56 46 56C47.5913 56 49.1174 55.3679 50.2426 54.2426C51.3679 53.1174 52 51.5913 52 50H56V43H58ZM26 53C25.2043 53 24.4413 52.6839 23.8787 52.1213C23.3161 51.5587 23 50.7956 23 50C23 49.2044 23.3161 48.4413 23.8787 47.8787C24.4413 47.3161 25.2043 47 26 47C26.7957 47 27.5587 47.3161 28.1213 47.8787C28.6839 48.4413 29 49.2044 29 50C29 50.7956 28.6839 51.5587 28.1213 52.1213C27.5587 52.6839 26.7957 53 26 53ZM23 35H28V40H19.08L23 35ZM46 53C45.2044 53 44.4413 52.6839 43.8787 52.1213C43.3161 51.5587 43 50.7956 43 50C43 49.2044 43.3161 48.4413 43.8787 47.8787C44.4413 47.3161 45.2044 47 46 47C46.7956 47 47.5587 47.3161 48.1213 47.8787C48.6839 48.4413 49 49.2044 49 50C49 50.7956 48.6839 51.5587 48.1213 52.1213C47.5587 52.6839 46.7956 53 46 53Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalesOrder);
export default __webpack_public_path__ + "static/media/sales-order.304bdaff.svg";
export { ForwardRef as ReactComponent };